import { render, staticRenderFns } from "./CustomMultiselectMenu.vue?vue&type=template&id=01da9eb6&scoped=true"
import script from "./CustomMultiselectMenu.vue?vue&type=script&lang=js"
export * from "./CustomMultiselectMenu.vue?vue&type=script&lang=js"
import style0 from "./CustomMultiselectMenu.vue?vue&type=style&index=0&id=01da9eb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01da9eb6",
  null
  
)

export default component.exports